export function initializeParams(obj) {
    const params = [];
    Object.keys(obj).forEach((key) => {
        if (obj[key] || obj[key] === 0)
            params.push(`${key}=${obj[key]}`);
    });
    return params;
}
export default initializeParams;
//# sourceMappingURL=initializeParams.js.map